import { lichenSclerosus } from "./initial/flow";

export const LichenSclerosusFlows = { lichenSclerosus };